import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input, Form } from 'reactstrap';


const ModalViaticos = ({ isOpen, onClose, onSave, viatico }) => {
    const initialState = {
        lugar: '',
        pasaje: '',
        hospedaje: '',
        alimentacion: '',
        adicional: '',
        tipo_viatico: 1
    };

    const [formData, setFormData] = useState(initialState);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (viatico) {
            setFormData({
                lugar: viatico.lugar || '',
                pasaje: viatico.pasaje || '',
                hospedaje: viatico.hospedaje || '',
                alimentacion: viatico.alimentacion || '',
                adicional: viatico.adicional || '',
                tipo_viatico: viatico.tipo_viatico || 1
            });
        } else {
            setFormData(initialState);
        }
    }, [viatico, isOpen]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        if (!formData.tipo_viatico) {
            alert("El tipo de viático es obligatorio.");
            return;
        }

        const dataToSave = {
            ...formData,
            lugar: formData.lugar ? formData.lugar.toUpperCase() : ''
        };

        setIsSaving(true);
        try {
            await onSave(dataToSave);
        } catch (error) {
            console.error("Error saving:", error);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="lg">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>{viatico ? 'EDITAR DETALLE DE VIÁTICO' : 'NUEVO DETALLE DE VIÁTICO'}</h1>
                    <Button className="close-btn" onClick={onClose}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <Form className="fila" onSubmit={(e) => e.preventDefault()}>
                        <FormGroup>
                            <Label for="tipo_viatico">Tipo de Viático: <span className="text-danger">*</span></Label>
                            <Input
                                type="select"
                                name="tipo_viatico"
                                id="tipo_viatico"
                                value={formData.tipo_viatico}
                                onChange={handleChange}
                                className="form-control"
                            >
                                <option value={1}>COLABORADOR</option>
                                <option value={2}>GERENTES</option>
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label for="lugar">Lugar:</Label>
                            <Input
                                type="text"
                                name="lugar"
                                id="lugar"
                                value={formData.lugar}
                                onChange={handleChange}
                                placeholder="Ingrese el lugar"
                                className="form-control"
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label for="pasaje">Pasaje (S/):</Label>
                            <Input
                                type="number"
                                name="pasaje"
                                id="pasaje"
                                value={formData.pasaje}
                                onChange={handleChange}
                                placeholder="0.00"
                                step="0.01"
                                min="0"
                                className="form-control"
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label for="hospedaje">Hospedaje (S/):</Label>
                            <Input
                                type="number"
                                name="hospedaje"
                                id="hospedaje"
                                value={formData.hospedaje}
                                onChange={handleChange}
                                placeholder="0.00"
                                step="0.01"
                                min="0"
                                className="form-control"
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label for="alimentacion">Alimentación (S/):</Label>
                            <Input
                                type="number"
                                name="alimentacion"
                                id="alimentacion"
                                value={formData.alimentacion}
                                onChange={handleChange}
                                placeholder="0.00"
                                step="0.01"
                                min="0"
                                className="form-control"
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label for="adicional">Adicional (S/):</Label>
                            <Input
                                type="number"
                                name="adicional"
                                id="adicional"
                                value={formData.adicional}
                                onChange={handleChange}
                                placeholder="0.00"
                                step="0.01"
                                min="0"
                                className="form-control"
                            />
                        </FormGroup>

                        <FormGroup>
                            <div className="button-container pb-4">
                                <Button className="button-custom" onClick={handleSubmit} disabled={isSaving}>
                                    {isSaving ? 'GUARDANDO...' : 'GUARDAR'}
                                </Button>
                            </div>
                        </FormGroup>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalViaticos;
